import {
    INFO_SIG
} from '../actions/types'

const INITIAL_STATE = {
    load_signatario: false,
    msg_response: '',
    error_response: false,
    tiposSignatarios: []
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case INFO_SIG:
            return { ...state, ...action.payload }
        default:
            return state
    }
}